import NBType from '@netbase/nb-type'

/**
 * @typedef {object} InternalSectionSchema
 * @property {string[]} excludedMetaTags
 * @property {string[]} excludedProductHierarchy
 * @property {boolean} includedInternal
 * @property {string[]} includedMetaTags
 * @property {string[]} includedProductHierarchy
 */
const InternalSectionSchema = NBType.object().shape('InternalSectionSchema', {
  /* @prop */
  excludedMetaTags: NBType.array().of(NBType.string()),
  /* @prop */
  excludedProductHierarchy: NBType.array().of(NBType.string()),
  /* @prop */
  includedInternal: NBType.boolean(),
  /* @prop */
  includedMetaTags: NBType.array().of(NBType.string()),
  /* @prop */
  includedProductHierarchy: NBType.array().of(NBType.string())
  /* END */
})
export default InternalSectionSchema
// RESERVE BELOW
